import '@core/utils/prototypes';


export class EntidadeFiltro {
  nomeFantasiaERazaoSocial?: string;
  cnpj?: string;
  status?: any;
  idGrupoEconomico?:any;
  idEntidadeSuperior?: boolean;
  tipoEntidade?: any;
  entidadeSuperior?: any;
}


export interface EntidadeElement {
  id: number;
  nomeFantasia?: string;
  nomeRazaoSocial?: string;
  cnpj: any;
  dataUltimaAtualizacao: string;
  statusEntidade: any;
  tipoEntidade?: any;
  subtipoEntidade?: string;
  excluido:boolean;
  entidadeSuperior?: string;
  entidadePertence?: any;
  entidadesSuperiores?: any;
  dataControleAtualizacao?: string;
  email: string;
}

export enum TipoEntidade {
    Confederacao = 'Confederação',
    Federacao = 'Federação',
    Sindicato = 'Sindicato',
    Seguradora = 'Seguradora',
    Reguladora = 'Reguladora',
    Corretora = 'Corretora',
    Capitalizacao = 'Capitalização',
    Saude = 'Saúde',
    Orgao = 'Órgão',
    Comissao = 'Comissão',
    GrupoTrabalho = 'Grupo de Trabalho',
    Subcomissao = 'Subcomissão',
    Previdência = 'Previdência',
    Previdencia = 'Previdência',
    EntidadesAfins = 'Entidades Afins',
    CompanhiasDoMercado = 'Companhias do Mercado',
    OutrasEntidades = 'Outras Entidades',
}

export enum TipoEntidadeEnum {
  Confederacao = 1,
  Federacao = 2,
  Sindicato = 3,
  Seguradora = 4,
  Reguladora = 5,
  Corretora = 6,
  Capitalizacao = 7,
  Saude = 8,
  Orgao = 9,
  Comissao = 10,
  GrupoTrabalho = 11,
  Subcomissao = 12,
  Previdencia = 13,
  OutrasEntidades = 14,
  Area = 51,
  CompanhiasDoMercado = 52,
}

export enum TipoContato {
  Email = 'Email',
  Telefone = 'Telefone',
  Endereço = 'Endereço',
  Juridica = 'Email Area Jurídica',
  Outros = 'Outros'
}

export enum TipoContatoEnum {
  EMAIL = 1,
  TELEFONE = 2,
  ENDERECO = 3,
  EMAILAREAJURIDICA = 4,
  OUTROS = 5,
  CONTATO_SECRETARIA = 6,
  AREA_ATUACAO = 10,
  DEFAULT = 99
}

export enum TipoRelacao {
  Organizacao = 'Organização',
  Associacao = 'Associação',
  Representacao = 'Representação'
}




